import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from '../actions';
import { Expertise, GridData, GridLookups, Offer } from 'src/app/shared/models/offers.model';
import { FetchArgs } from 'src/app/shared/models/core';
import { RecruitingDealAlertDto } from 'src/app/shared/models/recruiting-deal-alert-model';

export const initialGridState = (): FetchArgs => ({
    filter: {
        hideContractRequested: false,
        hideDeclinedAndRescinded: false
    },
    sort: { field: 'createdDate', dir: 'asc' },
    skip: 0,
    pageSize: 25
});

export interface DealsState {
    isHubConnectionActive: boolean;
    isLoading: boolean;
    deals: GridData;
    lookups: GridLookups;
    searchQuery: FetchArgs;
    offerInfo: Offer;
    expertise: Expertise[];
    recruitingDealAlertData: RecruitingDealAlertDto;
    error: unknown;
}

export const initialDealsState: DealsState = {
    isHubConnectionActive: false,
    isLoading: false,
    deals: null,
    lookups: null,
    searchQuery: initialGridState(),
    offerInfo: null,
    expertise: [],
    recruitingDealAlertData: null,
    error: undefined
};

export function dealsReducer(state: DealsState, action: Action) {
    return createReducer(
        initialDealsState,
        on(fromActions.RecruitingActions.DealsActions.loadOffers, (state) => ({
            ...state,
            isLoading: true
        })),

        on(fromActions.RecruitingActions.DealsActions.loadOffersSuccess, (state, action) => ({
            ...state,
            isLoading: false,
            deals: action.offers
        })),

        on(fromActions.RecruitingActions.DealsActions.loadOfferLookups, (state) => ({
            ...state,
            isLoading: true
        })),

        on(fromActions.RecruitingActions.DealsActions.loadOfferLookupsSuccess, (state, action) => ({
            ...state,
            isLoading: false,
            lookups: action.lookups
        })),

        on(
            fromActions.RecruitingActions.DealsActions.loadOfferLookupsFailure,
            fromActions.RecruitingActions.DealsActions.loadOffersFailure,
            (state, action) => ({
                ...state,
                isLoading: false,
                error: JSON.stringify(action.error)
            })
        ),
        on(fromActions.RecruitingActions.DealsActions.recruitingDealAlertSuccess, (state, action) => ({
            ...state,
            recruitingDealAlertData: action.data
        })),
        on(fromActions.RecruitingActions.DealsActions.recruitingDealAlertFailure, (state, action) => ({
            ...state,
            error: JSON.stringify(action.error)
        })),
        on(fromActions.RecruitingActions.DealsActions.getCandidateOffersRecruiterReviewCount, (state, action) => ({
            ...state,
            recruiterId: action.recruiterId,
            isLoading: true
        })),
        on(
            fromActions.RecruitingActions.DealsActions.getCandidateOffersRecruiterReviewCountSuccess,
            (state, action) => ({
                ...state,
                isLoading: false,
                recruitingDealAlertData: action.data
            })
        ),
        on(
            fromActions.RecruitingActions.DealsActions.getCandidateOffersRecruiterReviewCountFailure,
            (state, action) => ({
                ...state,
                isLoading: false,
                error: JSON.stringify(action.error)
            })
        ),
        on(fromActions.RecruitingActions.DealsActions.clearRecruiterDealAlertData, (state) => ({
            ...state,
            recruitingDealAlertData: null
        })),
        on(fromActions.RecruitingActions.DealsActions.setOffersGridSearchQuery, (state, action) => ({
            ...state,
            searchQuery: action.searchQuery,
            isLoading: true
        })),
        on(fromActions.RecruitingActions.DealsActions.setOfferAsVerballyAcceptedSuccess, (state, action) => {
            const data = state.deals.data.map((deal: any) => {
                let newDeal = deal;
                if (newDeal.offerId === action.offerId) {
                    newDeal = { ...deal };
                    newDeal.offerVerballyAccepted = true;
                }
                return newDeal;
            });
            return {
                ...state,
                deals :{
                    ...state.deals,
                    data : data
                }
            };
        })
    )(state, action);
}

export function reducer(state: DealsState | undefined, action: Action) {
    return dealsReducer(state, action);
}
